export interface MachineBrand {
  brand:  string;
  models: readonly string[];
}

export const MACHINE_CATALOG: readonly MachineBrand[] = [
  { brand: 'Bambu Lab',  models: ['A1 mini', 'A1 mini Combo', 'A1', 'A1 Combo', 'P1S', 'P1S Combo', 'X1C', 'X1C Combo', 'H2D'] },
  { brand: 'Snapmaker', models: ['U1', 'J1'] },
  { brand: 'Prusa',     models: ['MK4', 'MK4S', 'XL', 'Mini+'] },
  { brand: 'Creality',  models: ['K1 Max', 'K2 Plus', 'Ender 5 S1', 'Ender 3 V3'] },
  { brand: 'Anycubic',  models: ['Kobra 3', 'Kobra 3 Combo', 'Photon Mono X 6K'] },
  { brand: 'Voron',     models: ['2.4', 'Trident', 'Switchwire'] },
  { brand: 'Ultimaker', models: ['S5', 'S7', 'Factor 4'] },
  { brand: 'Outro',     models: ['Personalizado'] },
] as const;

// Tipos de arquivo aceitos em cotações (modelagem 3D e atestado de leigo)
export const QUOTE_FILE_ACCEPT = '.stl,.3mf,.doc,.docx,.xls,.xlsx,.pdf,.dwg,.dxf,.svg';
export const QUOTE_FILE_RE = /\.(stl|3mf|docx?|xlsx?|pdf|dwg|dxf|svg)$/i;
export const QUOTE_FILE_HINT = 'STL, 3MF, PDF, Word, Excel, DWG, DXF ou SVG';

export const MODELING_TYPES = [
  { value: 'organic',    label: 'Orgânica (personagens, bonecos, arte)' },
  { value: 'parametric', label: 'Paramétrica / CAD (peças técnicas)' },
] as const;

export const CAPABILITIES = [
  { value: 'multicolor',      label: 'Multicolorido' },
  { value: 'dual_extruder',   label: 'Duplo extrusor' },
  { value: 'enclosed',        label: 'Câmara fechada' },
  { value: 'large_volume',    label: 'Volume grande (>300mm)' },
  { value: 'high_temp',       label: 'Alta temperatura (>280°C)' },
  { value: 'flexible',        label: 'Filamentos flexíveis' },
];

export const MATERIALS = [
  { value: 'PLA',      label: 'PLA' },
  { value: 'PLA_PLUS', label: 'PLA+' },
  { value: 'ABS',      label: 'ABS' },
  { value: 'ASA',      label: 'ASA' },
  { value: 'PETG',     label: 'PETG' },
  { value: 'TPU',      label: 'TPU (Flexível)' },
  { value: 'NYLON',    label: 'Nylon' },
  { value: 'PC',       label: 'Policarbonato' },
  { value: 'PA_CF',    label: 'PA + Fibra de carbono' },
  { value: 'PEEK',     label: 'PEEK (Alta performance)' },
  { value: 'RESINA',   label: 'Resina (SLA/MSLA)' },
];

export const SPECIALIZATIONS = [
  { value: 'chaveiro',     label: 'Chaveiro / PET' },
  { value: 'action_figure',label: 'Action figures / Colecionáveis' },
  { value: 'cosplay',      label: 'Cosplay / Adereços' },
  { value: 'utilities',    label: 'Utilitários domésticos' },
  { value: 'decor',        label: 'Decoração' },
  { value: 'funcional',    label: 'Peças funcionais' },
  { value: 'engenharia',   label: 'Engenharia / Protótipos' },
  { value: 'medico',       label: 'Médico / Ortopédico' },
  { value: 'educacional',  label: 'Educacional' },
  { value: 'outro',        label: 'Outro' },
];
